import React from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { history } from 'index'
import {
  UserOutlined,
  // EditOutlined
} from '@ant-design/icons'
import {
  Menu,
  Dropdown,
  Avatar,
  Badge,
  Modal,
  // Button
} from 'antd'
import ChangePassword from 'pages/auth/changePassword'
import {
  // showChangePasswordModal,
  closeChangePasswordModal,
} from 'redux/register/actions'
import styles from './style.module.scss'

const mapStateToProps = ({ user, register }) => ({
  modalVisible: register.modalVisible,
  user,
})

const ProfileMenu = ({ dispatch, user, modalVisible }) => {
  const logout = e => {
    e.preventDefault()
    dispatch({
      type: 'LOG_OUT',
    })
    history.push('/auth/login')
  }

  // const addCount = () => {
  //   setCount(count + 1)
  // }

  // const showModal = () => {
  //   dispatch(showChangePasswordModal())
  // }

  const handleCancel = () => {
    dispatch(closeChangePasswordModal())
  }

  const menu = (
    <Menu selectable={false}>
      <Menu.Item>
        <strong>
          <FormattedMessage id="topBar.profileMenu.hello" />, {user.name || 'Anonymous'}
        </strong>
        {/* <div>
          <strong className="mr-1">
            <FormattedMessage id="topBar.profileMenu.billingPlan" />:{' '}
          </strong>
          Professional
        </div> */}
        {/* <div>
          <strong>
            <FormattedMessage id="topBar.profileMenu.role" />:{' '}
          </strong>
          {user.role || '—'}
        </div> */}
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item>
        <div>
          <strong>
            <FormattedMessage id="topBar.profileMenu.email" />:{' '}
          </strong>
          {user.email || '—'}
          <br />
          {/* <strong>
            <FormattedMessage id="topBar.profileMenu.phone" />:{' '}
          </strong>
          {user.phone || '—'} */}
        </div>
      </Menu.Item>
      {/* <Menu.Divider />
      <Menu.Item>
        <Button
          type="link"
          style={{ color: '#323232' }}
          icon={
            <EditOutlined style={{ marginLeft: '-17px', marginRight: '8px', color: '#323232' }} />
          }
          onClick={showModal}
        >
          <FormattedMessage id="topBar.profileMenu.changePassword" />
        </Button>
      </Menu.Item> */}
      <Menu.Divider />
      <Menu.Item>
        <a href="#" onClick={logout}>
          <i className="fe fe-log-out mr-2" />
          <FormattedMessage id="topBar.profileMenu.logout" />
        </a>
      </Menu.Item>
    </Menu>
  )
  return (
    <>
      <Modal
        visible={modalVisible}
        onCancel={() => handleCancel()}
        footer={null}
        // className={styles.modalBlock}
        // destroyOnClose
      >
        <ChangePassword />
      </Modal>
      <Dropdown overlay={menu}>
        <div className={styles.dropdown}>
          <Badge>
            <Avatar className={styles.avatar} shape="round" size="small" icon={<UserOutlined />} />
          </Badge>
        </div>
      </Dropdown>
    </>
  )
}

export default connect(mapStateToProps)(ProfileMenu)
